import _styled from "@emotion/styled/base";
import Icon from './Icon';
import { buttons, colors, colorsRaw, shadows } from './styles';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const sizes = {
  small: '28px',
  large: '40px'
};
const ButtonRound = /*#__PURE__*/_styled("button", {
  target: "em2wuvj0",
  label: "ButtonRound"
})(buttons.button, ";", shadows.dropMiddle, ";background-color:", colorsRaw.white, ";color:", props => colors[props.isActive ? `active` : `inactive`], ";border-radius:32px;display:flex;justify-content:center;align-items:center;width:", props => sizes[props.size], ";height:", props => sizes[props.size], ";padding:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29uQnV0dG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVpQyIsImZpbGUiOiIuLi8uLi9zcmMvSWNvbkJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJztcbmltcG9ydCB7IGJ1dHRvbnMsIGNvbG9ycywgY29sb3JzUmF3LCBzaGFkb3dzIH0gZnJvbSAnLi9zdHlsZXMnO1xuXG5jb25zdCBzaXplcyA9IHtcbiAgc21hbGw6ICcyOHB4JyxcbiAgbGFyZ2U6ICc0MHB4Jyxcbn07XG5cbmNvbnN0IEJ1dHRvblJvdW5kID0gc3R5bGVkLmJ1dHRvbmBcbiAgJHtidXR0b25zLmJ1dHRvbn07XG4gICR7c2hhZG93cy5kcm9wTWlkZGxlfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcnNSYXcud2hpdGV9O1xuICBjb2xvcjogJHtwcm9wcyA9PiBjb2xvcnNbcHJvcHMuaXNBY3RpdmUgPyBgYWN0aXZlYCA6IGBpbmFjdGl2ZWBdfTtcbiAgYm9yZGVyLXJhZGl1czogMzJweDtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHdpZHRoOiAke3Byb3BzID0+IHNpemVzW3Byb3BzLnNpemVdfTtcbiAgaGVpZ2h0OiAke3Byb3BzID0+IHNpemVzW3Byb3BzLnNpemVdfTtcbiAgcGFkZGluZzogMDtcbmA7XG5cbmZ1bmN0aW9uIEljb25CdXR0b24oeyBzaXplLCBpc0FjdGl2ZSwgdHlwZSwgb25DbGljaywgY2xhc3NOYW1lLCB0aXRsZSB9KSB7XG4gIHJldHVybiAoXG4gICAgPEJ1dHRvblJvdW5kXG4gICAgICBzaXplPXtzaXplfVxuICAgICAgaXNBY3RpdmU9e2lzQWN0aXZlfVxuICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgdGl0bGU9e3RpdGxlfVxuICAgID5cbiAgICAgIDxJY29uIHR5cGU9e3R5cGV9IHNpemU9e3NpemV9IC8+XG4gICAgPC9CdXR0b25Sb3VuZD5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgSWNvbkJ1dHRvbjtcbiJdfQ== */"));
function IconButton({
  size,
  isActive,
  type,
  onClick,
  className,
  title
}) {
  return _jsx(ButtonRound, {
    size: size,
    isActive: isActive,
    className: className,
    onClick: onClick,
    title: title,
    children: _jsx(Icon, {
      type: type,
      size: size
    })
  });
}
export default IconButton;